/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourtHearingDutyCounselorResponse
 */
export interface CourtHearingDutyCounselorResponse {
    /**
     * 
     * @type {string}
     * @memberof CourtHearingDutyCounselorResponse
     */
    userCode: string;
    /**
     * 
     * @type {string}
     * @memberof CourtHearingDutyCounselorResponse
     */
    displayName: string | null;
}

/**
 * Check if a given object implements the CourtHearingDutyCounselorResponse interface.
 */
export function instanceOfCourtHearingDutyCounselorResponse(value: object): value is CourtHearingDutyCounselorResponse {
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function CourtHearingDutyCounselorResponseFromJSON(json: any): CourtHearingDutyCounselorResponse {
    return CourtHearingDutyCounselorResponseFromJSONTyped(json, false);
}

export function CourtHearingDutyCounselorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtHearingDutyCounselorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userCode': json['userCode'],
        'displayName': json['displayName'],
    };
}

export function CourtHearingDutyCounselorResponseToJSON(json: any): CourtHearingDutyCounselorResponse {
    return CourtHearingDutyCounselorResponseToJSONTyped(json, false);
}

export function CourtHearingDutyCounselorResponseToJSONTyped(value?: CourtHearingDutyCounselorResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userCode': value['userCode'],
        'displayName': value['displayName'],
    };
}

